﻿var vm;
(function () {
    'use strict';
    var controllerId = 'equipmentDamageController';

    angular
        .module('app.controllers')
        .controller(controllerId, equipmentDamageController)
        .directive('a', aDirective)
        .controller('ModalController', ModalController)
        .controller('ModalControllerCustomer', ModalControllerCustomer)
        .directive('carouseloption', carouseloption);

    carouseloption.$inject = ['ModalService'];

    function aDirective() {
        return {
            restrict: 'E',
            link: function (scope, elem, attrs) {
                var link = String(attrs.href);
                var result = link.includes('myCarousel');
                if (result) {
                    elem.on('click', function (e) {
                        e.preventDefault();
                    });
                }
            }
        };
    }

    function carouseloption() {
        return {
            restrict: 'EA',//<dir-template></dir-template> hace referencia a un elemento/etiqueta html
            transclude: false,
            template:
                    '<div class="container">' +
                    '<a data-ng-disabled="prevDisabled" ng-if="listdata.length > 0" class="col-lg-1 col-xs-1 col-md-1 col-sm-1 navigationSlider"  data-slide="prev"><i ng-class="classPrev" data-ng-click="prev()"></i></a>' +
                    '<div class="col-lg-2 col-xs-2 col-md-2 col-sm-2" data-ng-repeat="imgList in listdata" data-ng-show="ls[$index]" data-ng-click="current=$index">' +
                    //'<img ng-src="{{imgList.Url}}" data-ng-click="showModal(imgList.Url)" class="img-responsive">{{imgList.MRInspectionImageId}}' +
                    '<img ng-src="{{imgList.Url}}" data-ng-click="showModal(imgList.Url)" class="img-responsive">' +
                    '</div>' +
                    '<a data-ng-disabled="nextDisabled" ng-if="listdata.length > 0" class="col-lg-1 col-xs-1 col-md-1 col-sm-1 navigationSlider"  data-slide="next"><i ng-class="classNext" data-ng-click="next()"></i></a>' +
                    '</div>',
            scope: {
                listdata: "="
            },
            link: function (scope, element, ModalService) {
                var classDisabled = " lessOpacity";
                var classleft = "glyphicon glyphicon-chevron-left";
                var classright = "glyphicon glyphicon-chevron-right";
                scope.classPrev = classleft;
                scope.classNext = classright;
                scope.prevDisabled = scope.listdata.length > 5;
                scope.nextDisabled = scope.listdata.length > 5;
                scope.ls = [];
                scope.currentInit = 0;
                scope.currentFin = 4;
                function init() {
                    for (var i = 0; i < scope.listdata.length; i++) {
                        scope.ls[i] = ((i < 5) ? true : false);
                    }
                }

                scope.showModal = function (imageUrl) {
                    scope.$emit('someEvent', imageUrl);
                };

                scope.prev = function () {
                    if (scope.listdata.length > 5) {
                        if (!angular.isUndefined(scope.ls[scope.currentInit - 1])) {
                            scope.ls[scope.currentInit - 1] = true;
                            scope.ls[scope.currentFin] = false;
                            scope.currentInit = scope.currentInit - 1;
                            scope.currentFin = scope.currentFin - 1;
                            scope.classPrev = classleft;
                            scope.classNext = classright;
                        } else {
                            scope.classPrev = classleft + classDisabled;
                        }
                    }
                }

                scope.next = function () {
                    if (scope.listdata.length > 5) {
                        if (!angular.isUndefined(scope.ls[scope.currentFin + 1])) {
                            scope.ls[scope.currentFin + 1] = true;
                            scope.ls[scope.currentInit] = false;
                            scope.currentInit = scope.currentInit + 1;
                            scope.currentFin = scope.currentFin + 1;
                            scope.classNext = classright;
                            scope.classPrev = classleft;
                        }
                        else {
                            scope.classNext = classright + classDisabled;
                        }
                    }
                }

                init();
            }
        };
    };

    equipmentDamageController.$inject = ['common', 'datacontext', '$http', '$scope',
            '$translate', '$timeout', '$state', '$element', '$sce', '$window', '$stateParams',
            'vsblockui', '$compile', 'ModalService'];

    function equipmentDamageController(common, datacontext, $http, $scope, $translate,
            $timeout, $state, $element, $sce, $window, $stateParams, vsblockui, $compile, ModalService) {

        $scope.$on('someEvent', function (event, data) {
            $scope.showModal(data);
        });
        $scope.viewCarrierName = false;

        vm = this;
        var CONSTANTS = {
            QUANTITY_BASE_SCROLL: 9,
            QUANTITY_BASE_SCROLL_INS: 6,
            QUANTITY_BASE_SCROLL_PTI: 6
        };
        vm.spinnerOptions = {
            radius: 20,
            lines: 11,
            length: 1,
            width: 8,
            speed: 1.7,
            corners: 1.0,
            trail: 100,
            color: '#146794'
        };

        //vm.actionRefresh = false;
        vm.viewDamageInformation = false;

        vm.actionSelected = false;
        vm.actionSearch = false;
        vm.actionDetail = false;

        vm.selectedEquipment = {};
        vm.equipmentDamage = [];

        function init2() {
            common.activateController().then(function (data) {
                var associateCarrier = common.localStorageService.get('GetBusinessPartnerUserRolesQuery');
                if (associateCarrier && associateCarrier.Name) {
                    $scope.viewCarrierName = true;
                    vm.CarrierName = associateCarrier.Name;
                } else {
                    $scope.viewCarrierName = false;
                    vm.CarrierName = $translate.instant('views.equipmentDamage.allCarrierName');
                }
            });
        }

        //var lbl_All = $translate.instant('views.equipmentDamage.all');

        //$scope.getEquipmentsByNo = function (criteria) {
        //    return datacontext.equipmentdamage.getEquipmentsByNo(criteria);
        //};

        vm.clear = function () {
            $scope.$broadcast('angucomplete-alt:clearInput');
            vm.equipmentSelected.originalObject = undefined;
            vm.viewDamageInformation = false;
            $scope.viewNoResultEquipmentDamage = false;
            vm.viewErrorEquipmentDamage = false;
            vm.viewErrorInformation = false;
            vm.viewNoResultInformation = false;
            vm.informationDamage = false;
            $("#EquipmentNoDamage").val('');
        }

        vm.equipmentSelected = {};
        //$scope.selectedEquipmentFn = function (selected) {
        //    if (selected != undefined) {
        //        vm.viewDamageInformation = false;
        //        vm.informationDamage = false;
        //        $scope.viewNoResultEquipmentDamage = false;
        //        vm.viewErrorEquipmentDamage = false;
        //        vm.actionSelected = true;
        //        vm.actionSearch = false;
        //        vm.actionDetail = false;
        //        vm.equipmentSelected = selected;
        //        vm.informationDamage = false;
        //        vm.clickBuscar();
        //    }
        //}

        vm.viewDamageInformation = false;
        vm.searchStr = '';

        vm.clickBuscar = function () {
            vm.viewDamageInformation = false;
            $scope.viewNoResultEquipmentDamage = false;
            vm.viewErrorEquipmentDamage = false;
            vm.actionSearch = true;
            vm.informationDamage = false;
            vm.GetEquipmentInfo();
        }

        vm.preLoadA = false;
        vm.viewNoResultInformation = false;
        vm.viewDamageInformation = false;
        vm.viewErrorInformation = false;
        vm.listImagen = [];
        vm.model = {};

        vm.setModel = function () {
            vm.equipmentSelected = { originalObject: { EquipmentNo: $('#EquipmentNoDamage').val() } };
            var model = {
                EquipmentNo: vm.equipmentSelected.originalObject.EquipmentNo,
                LanguageId: 1,
                Parameters: {
                    page: 1,
                    take: 1000000
                }
            }
            vm.model = model;
        }

        vm.buscar = function () {
            vm.setModel();

            if (vm.model.EquipmentNo == null || vm.model.EquipmentNo == "") {
                toastr.info("Ingresar Numero de Equipo");
                return false;
            }
            
            var associateCarrier = common.localStorageService.get('GetBusinessPartnerUserRolesQuery');
            vm.CarrierName = associateCarrier.Name;

            if (vm.model.EquipmentNo !== undefined) {
                vm.informationDamage = false;
                return datacontext.equipmentdamage.getEquipmentDamageByCriteria(vm.model).then(function (data) {
                    vm.viewErrorequipmentDamage = false;
                    $scope.viewNoResultEquipmentDamage = false;
                    vm.actionSelected = false;
                    vm.actionSearch = false;
                    vm.informationDamage = true;
                    if (data.length > 0) {
                        $scope.currentDamages = 0;
                        vm.informationDamage = true;
                        vm.equipmentDamage = data;
                        /*var obj = angular.copy(data);
                        console.log(data)
                        vm.equipmentDamage.push(obj[0]);*/
                        vm.viewDamageInformation = true;
                        vm.viewErrorequipmentDamage = false;
                        $scope.viewNoResultEquipmentDamage = false;

                        inicialize(0, vm.equipmentDamage);
                    }
                    else {
                        vm.informationDamage = false;
                        vm.viewDamageInformation = false;
                        $scope.viewNoResultEquipmentDamage = true;
                        vm.viewErrorequipmentDamage = false;
                        vm.actionSelected = false;
                        vm.actionSearch = false;
                        vm.actionDetail = false;
                    }
                    //vm.actionRefresh = false;
                },
                function (err) {
                    vm.viewDamageInformation = false;
                    vm.viewErrorequipmentDamage = true;
                    $scope.viewNoResultEquipmentDamage = false;
                    vm.actionSelected = false;
                    vm.actionSearch = false;
                    vm.actionDetail = false;
                    //vm.actionRefresh = false;
                    if (err.status)
                        toastr.error(err.info);
                });
            }
        }


        vm.addScroll = function () {
            var scroll = '';
            if (vm.equipmentDamage.length >= CONSTANTS.QUANTITY_BASE_SCROLL) {
                scroll = 'table-y-300';
            }
            else {
                scroll = '';
            }
            return scroll;
        };

        vm.addScrollINS = function () {
            var scroll = '';
            if (vm.listINS.length >= CONSTANTS.QUANTITY_BASE_SCROLL_INS) {
                scroll = 'table-y-200';
            }
            else {
                scroll = '';
            }
            return scroll;
        };

        vm.addScrollPTI = function () {
            var scroll = '';
            if (vm.listPTI.length >= CONSTANTS.QUANTITY_BASE_SCROLL_PTI) {
                scroll = 'table-y-200';
            }
            else {
                scroll = '';
            }
            return scroll;
        };

        init2();
        /*---------*/

        vm.GetEquipmentInfo = function () {
            var value = $('#EquipmentNoDamage').val();

            if (value.length === 0) {
                vm.actionSelected = false;
                vm.actionSearch = false;
                vm.actionDetail = false;
                toastr.info($translate.instant('views.equipmentDamage.selectEquipmentAutoComplete'));

            } else if (value.length > 0 && value.length < 8) {
                toastr.info($translate.instant('views.equipmentDamage.equipmentMinimumCharacters'));

            } else {
                //vm.actionRefresh = true;
                return datacontext.equipmenttracking.getEquipmentsByNo($('#EquipmentNoDamage').val()).then(function (data) {
                    var selected = {
                        originalObject: $(data)[0]
                    };

                    if ($(data)[0]) {
                        vm.viewDamageInformation = false;
                        vm.informationDamage = false;
                        $scope.viewNoResultEquipmentDamage = false;
                        vm.viewErrorEquipmentDamage = false;
                        vm.actionSelected = true;
                        vm.actionSearch = false;
                        vm.actionDetail = false;
                        vm.equipmentSelected = selected;
                        //vm.clickBuscar();
                        vm.setModel();

                        toastr.info('Equipo ' + selected.originalObject.EquipmentNo + ' encontrado.');
                        vm.buscar();
                    }
                    else {
                        toastr.info($translate.instant('views.equipmentDamage.equipmentNotFound'));
                        //vm.actionRefresh = false;
                    }
                },
                    function (err) {
                        vm.viewDamageInformation = false;
                        vm.viewErrorequipmentDamage = true;
                        $scope.viewNoResultEquipmentDamage = false;
                        vm.actionSelected = false;
                        vm.actionSearch = false;
                        vm.actionDetail = false;
                        //vm.actionRefresh = false;
                        if (err.status)
                            toastr.error(err.info);
                    }
                );
            }
        };

        $scope.onBlur = function ($event) {
            var value = $('#EquipmentNoDamage').val();
            if (value.length < 8) {
                toastr.info('El equipo debe tener minimo 8 caracteres.');
                return;
            }

            //vm.actionRefresh = true;
            return datacontext.equipmenttracking.getEquipmentsByNo($('#EquipmentNoDamage').val()).then(function (data) {
                var selected = {
                    originalObject: $(data)[0]
                };

                if ($(data)[0]) {
                    vm.viewDamageInformation = false;
                    vm.informationDamage = false;
                    $scope.viewNoResultEquipmentDamage = false;
                    vm.viewErrorEquipmentDamage = false;
                    vm.actionSelected = true;
                    vm.actionSearch = false;
                    vm.actionDetail = false;
                    vm.equipmentSelected = selected;
                    vm.informationDamage = false;
                    vm.clickBuscar();

                    //vm.actionRefresh = false;
                    toastr.info('Equipo ' + selected.originalObject.EquipmentNo + ' encontrado.');
                }
                else {
                    toastr.info('Ingrese nuevamente el equipo.');
                }
            },
                function (err) {
                    if (err.status)
                        toastr.error(err.info);
                });
        }

        $scope.currentDamages = 0;
        $scope.listActive = [];
        $scope.classInfo = ['alertEdit alert-infoEdit', 'alertEdit alert-infoEdit alertSelect'];

        function inicialize(position, lst) {
            for (var i = 0; i < lst.length; i++) {
                $scope.listActive[i] = ((i == position) ? true : false);
            }
        }

        $scope.currentDamages = 0;
        $scope.listActive = [];
        $scope.imagesSlider = 5;
        vm.inspectionItem = function (index) {
            $scope.currentDamages = index;
            inicialize(index, $scope.listActive);
        };




        $scope.showModal = function (imageUrl) {

            $scope.imageUrl = imageUrl;
            ModalService.showModal({
                templateUrl: "myModalImage.html",
                controller: "ModalController",
                inputs: {
                    title: "Foto del Daño",
                    uri: imageUrl
                }
            }).then(function (modal) {
                modal.element.modal();
                modal.close.then(function (result) {
                    //$scope.complexResult = "Name: " + result.name + ", age: " + result.age;
                });
            }).catch(function (error) {
                // error contains a detailed error message.
                console.log(error);
            });

        };

        $scope.showCustom = function () {
            ModalService.showModal({
                templateUrl: "myModalImageCustomer.html",
                controller: "ModalControllerCustomer"
            }).then(function (modal) {
                modal.element.modal();
                modal.close.then(function (result) {
                    $scope.customResult = "All good!";
                });
            },
                function (err) {
                    if (err.status)
                        toastr.error(err.info);
                });

        };


        function toggleChevron(e) {
            $(e.target)
                .prev('.panel-heading')
                .find("i.indicator")
                .toggleClass('glyphicon-chevron-down glyphicon-chevron-up');
        }
        $('#accordion').on('hidden.bs.collapse', toggleChevron);
        $('#accordion').on('shown.bs.collapse', toggleChevron);
    }

    function ModalController($scope, $element, title, close, uri) {
        $scope.imageUrl = uri;
        $scope.name = null;
        $scope.age = null;
        $scope.title = title;


        $scope.close = function () {
            close({
                name: $scope.name,
                age: $scope.age
            }, 500); // close, but give 500ms for bootstrap to animate
        };


        $scope.cancel = function () {
            $element.modal('hide');

            close({
                name: $scope.name,
                age: $scope.age
            }, 500); // close, but give 500ms for bootstrap to animate
        };
    };

    function ModalControllerCustomer($scope, close) {
        $scope.close = close;
    };
})();